import { Box, Typography, Divider } from "@mui/material";
import Assets from "./Assets";
import basestyle from "../../CSS/Base.module.css";
import Labilities from "./Labilities";
import Capital from "./Capital";
import Expenses from "./Expenses";
import { useNavigate } from "react-router-dom";
import { getBankSummaryByPId } from "../services/Summary/accountSummaryService";
import * as constants from "../../../constants";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { RootState } from "../../../store/store";
import { AxiosError } from "axios";
import { formatCurrency } from "../Utils/formatUtils";
import assetsIcon from '../../../assets/images/Bank-removebg-preview.png';
import { SectionTitle, StyledParentContainer, StyledSummaryContainer } from "../StyledComponents/Container";
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from "react-i18next";
import environment from "../../../environments/environment";
import { getClientDetailsByClientName } from "../Utils/ClientSettingsTable";

const Summary = () => {
  const navigate = useNavigate();
  const userInfo = useSelector((state: RootState) => state.auth);
  const [bankDetails, setBankDetails] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const ClientDetails = getClientDetailsByClientName(userInfo?.clientVo?.name);
  const translate = t as (key: string) => string;

  const restrictedRoles = [constants.ROLES_BUDGET_ANALYST];
  const restrictedBankSummary = [constants.ROLES_ADMIN_MANAGER, constants.ROLES_ADMIN_USER]
  const isRestrictedUser = restrictedRoles.includes(userInfo?.roles?.roleName || "");
  const isRestrictedBankSummary = restrictedBankSummary.includes(userInfo?.roles?.roleName || "");
  const restrictedReadonlyRoles = [
    constants.ROLES_READ_ONLY_USER,
    constants.ROLES_PROJECT_APPROVER,
    constants.ROLES_READ_ONLY_ALL_LOCATIONS,
    constants.ROLES_PARTICIPANT_USER
  ];
  const isRestrictedReadyUser = restrictedReadonlyRoles.includes(userInfo?.roles?.roleName || "");
  useEffect(() => {
    getBankSummary(userInfo.defaultParticipantId, userInfo.clientId);
  }, [userInfo?.defaultParticipantId]);

  function summaryDetailsPage(e: React.MouseEvent<HTMLTableCellElement>, bnkDetails: any) {
    e.preventDefault();
    navigate("/summaryDetails", { state: { bnkDetails } });
  }


  async function getBankSummary(pId: number, clientId: number) {
    setLoading(true); // Start loading
    try {
      const resBankSummary = await getBankSummaryByPId(pId, clientId);
      if (resBankSummary.status == constants.STATUS_CODES.SUCCESS) {
        setBankDetails(resBankSummary?.data?.data);
      }
    } catch (error: any) {
      setBankDetails([]);
      if (error instanceof AxiosError) {
        console.error(error.response?.data?.message || translate('somethingWentWrong'));
      } else {
        console.error(translate('anUnexpectedError'));
      }
    } finally {
      setLoading(false); // Stop loading
    }
  }

  return (
    <>
      <StyledParentContainer>
        {/* Header inside secondcontainer */}
        <StyledSummaryContainer sx={{ border: "none", width: "100%" }}>
          <SectionTitle>{translate('accountSummary')}</SectionTitle>
          <Box sx={{ p: 2, background: environment.generalSettings ? 'rgba(255, 255, 255, 0.5)' : 'white', mb: 1 }}>
            {(ClientDetails?.bankSweepApplicable === constants.IS_ACTIVE_YES && isRestrictedBankSummary) && <>
              <Box sx={{ mb: 2 }}  >
                <Typography variant="h6" className={`${basestyle.bankSummaryText}`}>
                  {translate('bankSummary')}
                </Typography>
                <Divider sx={{ borderBottomWidth: "3px", backgroundColor: "#b2ebf2" }} />
                {loading ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Typography sx={{ display: 'flex', alignItems: 'center' }}>
                      <CircularProgress size={16} sx={{ mr: 1 }} />
                      Loading...
                    </Typography>
                  </Box>

                ) : bankDetails?.length > 0 ? (
                  bankDetails?.map((bank, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        mt: 1
                      }}
                    >
                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Box className={basestyle.circleWhite}>
                          <img
                            src={assetsIcon}
                            alt="Expenses Logo"
                            className="LabilitiesLogo"
                            style={{ marginTop: 2, width: "60px", height: "auto" }}
                          />
                        </Box>
                        <Typography
                          sx={{ ml: 1, cursor: "pointer", color: "blue", fontSize: "16px", }}
                          onClick={(e: any) => summaryDetailsPage(e, bankDetails[index])}
                        >
                          {`${bank.bankName} - ${bank.accountNumber.slice(-4)}`}
                        </Typography>
                      </Box>
                      <Typography className={`${basestyle.amountTotalAvaliable}`} sx={{ paddingRight: "2%" }}>
                        {formatCurrency(bank.availableBalance)}
                      </Typography>
                    </Box>
                  ))
                ) : (
                  <Typography sx={{ mt: 2, ml: 2 }}>
                    <strong> No bank details available.</strong>
                  </Typography>
                )}
              </Box>
            </>
            }

            <Typography variant="h6" className={`${basestyle.bankSummaryText}`}>
              {translate('dlSummary')}
            </Typography>
            <Divider sx={{ borderBottomWidth: "3px", backgroundColor: "#b2ebf2", mb: 1 }} />
            {isRestrictedUser ? (
              <Assets />
            ) : (
              <>
                <Assets />
                <Box sx={{ marginTop: 2 }}>
                  <Labilities />
                </Box>
                {!isRestrictedReadyUser && <>
                  <Box sx={{ marginTop: 2 }}>
                    <Capital />
                  </Box>
                  <Box sx={{ marginTop: 2 }}>
                    <Expenses />
                  </Box>
                </>}
              </>
            )}

          </Box>
        </StyledSummaryContainer>
      </StyledParentContainer>
    </>
  );
};

export default Summary;
